// Redux
import api from '../redux-api';
import { Action, ApiAction, AsyncResult } from '..';

// Types
import KycQuestionnaire from '@/types/kyc-questionnaire';
import RiskProfileItem from '@/types/risk-profile-item';
import SavedSections from '@/types/saved-sections';
import { CorrelateRiskProfilesState } from '@/redux/modules/types/correlate-risk-profiles';

// Initial State
const INITIAL_STATE: CorrelateRiskProfilesState = {};

// Actions
const CALCULATE_CORRELATE_RISK_PROFILE: ApiAction = {
  type: 'connect/correlate/calculate',
  endpoint: 'risk-profiles/calculate',
};

export default function reducer(state: CorrelateRiskProfilesState = INITIAL_STATE, action: Action): CorrelateRiskProfilesState {
  switch (action.type) {
    case CALCULATE_CORRELATE_RISK_PROFILE.type:
    case `${CALCULATE_CORRELATE_RISK_PROFILE.type}_SUCCESS`:
    case `${CALCULATE_CORRELATE_RISK_PROFILE.type}_ERROR`: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export const calculateCorrelateRiskProfile =
  (currentKycQuestionnaire: KycQuestionnaire, savedSections: SavedSections): AsyncResult<{ calculatedConfig?: RiskProfileItem; score?: number }> =>
  dispatch =>
    api.post(CALCULATE_CORRELATE_RISK_PROFILE, null, { currentKycQuestionnaire, savedSections }).then((res: { data: any }) => res.data);
